<ion-item lines="none" [ngClass]="{ disabled: this.disabledAndChecked }">
  <div
    class="d-flex-col item-container"
    [ngClass]="{ 'result-container': articleItemPage === 'result' }">
    <div class="d-flex article">
      <ion-checkbox
        *ngIf="articleItemPage === 'product-catalog'"
        [checked]="selected || disabledAndChecked"
        [disabled]="this.disabledAndChecked"
        (ionChange)="toggle()"></ion-checkbox>
      <ng-container *ngIf="imgUrl$ | async as imgUrl">
        <efp-thumbnail-action-item
          [ngClass]="{ 'result-image-web': articleItemPage === 'result' }"
          [imgSrc]="imgUrl"
          [title]="article.name"
          [artNr]="article.articleId"></efp-thumbnail-action-item
      ></ng-container>

      <!-- content - title & article number & result info -->
      <div class="d-flex ion-align-items-center top-container">
        <div class="d-flex title-info-container">
          <div class="title-container">
            <ng-container *ngIf="imgUrl$ | async as imgUrl">
              <efp-thumbnail-action-item
                *ngIf="articleItemPage === 'result'"
                [ngClass]="{ 'result-image-mobile': articleItemPage === 'result' }"
                [imgSrc]="imgUrl"
                [title]="article.name"
                [artNr]="article.articleId"></efp-thumbnail-action-item>
            </ng-container>
            <ion-note class="primary-title" text-wrap id="name">{{ article.name }}</ion-note>
          </div>

          <!-- article number -->
          <ion-note
            [ngClass]="{ 'result-page': articleItemPage === 'result' }"
            class="article-number d-flex"
            *ngIf="showArticleNumber">
            <span>{{ 'GENERAL.ARTICLE_NUMBER' | translate }}: </span>
            {{ article.articleId }}
          </ion-note>

          <!-- calculation -->
          <ion-note *ngIf="showCalculation" class="show-on-web">
            <ng-container *ngTemplateOutlet="calculationTemplate"></ng-container>
          </ion-note>

          <efp-article-cycle-quantities *ngIf="showCycleQuantity" [article]="article">
            <span>{{ 'CYCLE.ARTICLE.TITLE' | translate }}: </span>
          </efp-article-cycle-quantities>
        </div>

        <!-- end slot - input + delete button -->
        <div *ngIf="showArticleAmount || deletable" class="d-flex end-container">
          <div
            *ngIf="
              showArticleAmount &&
              articleForm &&
              (articleItemPage !== 'product-catalog' || selected)
            "
            [formGroup]="articleForm"
            [ngClass]="{ groupByCycles: this.cycleNumber !== null }"
            class="d-flex input-container">
            <doka-number-input
              efpInputKeyboard
              *ngIf="cycleNumber == null; else cycleAmount"
              [disabled]="false"
              [showStep]="true"
              [efpInputRestriction]="numberValidationRegex"
              efpInputOverwritingSelect
              [formControlName]="article.articleId"
              attr.data-test-selector="stock-list-item-{{ article.articleId }}">
            </doka-number-input>

            <!-- disabled number for cycle quantity -->
            <ng-template #cycleAmount>
              <doka-number-input
                [disabled]="true"
                [showStep]="true"
                [value]="article.cycleUsage ? article.cycleUsage[cycleNumber! - 1] : 0">
              </doka-number-input>
            </ng-template>
          </div>

          <button
            class="action-icon action-icon-large"
            (click)="deleteArticle(article.articleId)"
            *ngIf="deletable && articleItemPage !== 'product-catalog'">
            delete
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showCalculation" class="show-on-mobile">
      <!-- calculation -->
      <ng-container *ngTemplateOutlet="calculationTemplate"></ng-container>
    </div>
  </div>
</ion-item>
<ng-template #calculationTemplate>
  <div class="flex gap-sm items-center">
    <div class="text-sm">
      <span>{{ 'STOCK.CALCULATION.DEMAND' | translate }} ( </span>{{ article.demand }}
      <span>) - {{ 'STOCK.CALCULATION.STOCK' | translate }} (</span>
      {{ article.stock }}
      <span>) = {{ 'STOCK.CALCULATION.DIFFERENCE' | translate }} (</span>
      {{ article.difference && article.difference > 0 ? article.difference : 0 }}
      <span>)</span>
    </div>

    <span
      *ngIf="!hasEnoughAmount"
      class="text-icon text-text-icon font-icon text-text-warning"
      efpTooltip
      [tooltipTitle]="'STOCK.CALCULATION.TOOLTIP_DIFFERENCE_NEGATIVE' | translate"
      [placement]="TooltipPosition">
      south
    </span>

    <span
      class="text-icon text-text-icon font-icon text-text-information"
      *ngIf="wasEdited && hasEnoughAmount"
      efpTooltip
      [tooltipTitle]="'STOCK.CALCULATION.TOOLTIP_DIFFERENCE_POSITIVE' | translate"
      [placement]="TooltipPosition">
      north
    </span>
  </div>
</ng-template>
